// Prüfen, ob der Konfigurator auf der Seite vorhanden ist
if (document.querySelector('.konfigurator-container')) {
    // Lade Varianten aus ACF-Repeater (wird von PHP eingebettet)
    let varianten = [];
    if (typeof konfiguratorVarianten !== 'undefined') {
        varianten = konfiguratorVarianten;
    }

    // Bilder vorladen, um Netzwerk-Ladezeit zu minimieren
    function preloadImages() {
        varianten.forEach(variante => {
            if (variante.bild_url) {
                const img = new Image();
                img.src = variante.bild_url;
            }
        });
    }

    // Funktion zum Aktualisieren des Bildes und Datenblatts
    function updateBild(modell, rahmenfarbe, kissenfarbe, isHover = false) {
        const datenblattLink = document.getElementById('datenblatt-link');
        const alleBilder = document.querySelectorAll('.konfigurator-container img[class*="variant-img-"]');
        
        // Alle Bilder unsichtbar machen
        alleBilder.forEach(img => {
            img.style.opacity = '0';
            img.style.visibility = 'hidden';
        });
        // console.log('test');
        // Suche passende Variante
        const variante = varianten.find(v => 
            v.modell === modell &&
            v.rahmenfarbe === rahmenfarbe &&
            v.kissenfarbe === kissenfarbe
        );
        
        // Zeige Bild und Datenblatt oder Fehlermeldung
        if (variante && variante.bild_url) {
            const variantClass = `variant-img-${modell}-${rahmenfarbe}-${kissenfarbe}`;
            const vorschauBild = document.querySelector(`.${variantClass}`);
            
            if (vorschauBild) {
                vorschauBild.style.opacity = '1';
                vorschauBild.style.visibility = 'visible';
                
                // Trigger Sirv-Update (falls nötig)
                if (typeof Sirv !== 'undefined' && Sirv.SIRV && typeof Sirv.SIRV.update === 'function') {
                    Sirv.SIRV.update();
                }
                
                // Fallback: Benutzerdefiniertes Event auslösen
                const event = new Event('sirv-update');
                vorschauBild.dispatchEvent(event);
            } 
            
            if (variante.datenblatt_url && !isHover) {
                datenblattLink.href = variante.datenblatt_url;
                datenblattLink.textContent = 'Datenblatt Download';
                datenblattLink.style.display = 'block';
            } else if (!isHover) {
                datenblattLink.href = '';
                datenblattLink.textContent = '';
                datenblattLink.style.display = 'none';
            }
        } else if (!isHover) {
            datenblattLink.href = '';
            datenblattLink.textContent = '';
            datenblattLink.style.display = 'none';
            alert('Diese Kombination ist nicht verfügbar.');
        }
    }

    // Funktion zum Abrufen der aktuell ausgewählten Werte
    function getSelectedValues() {
        return {
            modell: document.querySelector('input[name="modell"]:checked').value,
            rahmenfarbe: document.querySelector('input[name="rahmenfarbe"]:checked').value,
            kissenfarbe: document.querySelector('input[name="kissenfarbe"]:checked').value
        };
    }

    // Event-Listener für Änderungen (Klick)
    document.querySelectorAll('input[name="modell"], input[name="rahmenfarbe"], input[name="kissenfarbe"]').forEach(input => {
        input.addEventListener('change', () => {
            const { modell, rahmenfarbe, kissenfarbe } = getSelectedValues();
            updateBild(modell, rahmenfarbe, kissenfarbe);
        });

        // Event-Listener für Hover
        // input.addEventListener('mouseover', () => {
        //     const group = input.name;
        //     const value = input.value;
        //     const currentValues = getSelectedValues();
            
        //     // Nur die aktuelle Option ändern, andere bleiben auf ausgewähltem Wert
        //     updateBild(
        //         group === 'modell' ? value : currentValues.modell,
        //         group === 'rahmenfarbe' ? value : currentValues.rahmenfarbe,
        //         group === 'kissenfarbe' ? value : currentValues.kissenfarbe,
        //         true
        //     );
        // });

        // // Bei Mouseout zurück zu ausgewählten Werten
        // input.addEventListener('mouseout', () => {
        //     const { modell, rahmenfarbe, kissenfarbe } = getSelectedValues();
        //     updateBild(modell, rahmenfarbe, kissenfarbe);
        // });
    });

    // Initiales Bild und Datenblatt laden
    document.addEventListener('DOMContentLoaded', () => {
        preloadImages(); // Bilder vorladen
        // Alle Bilder initial mit Sirv rendern
        if (typeof Sirv !== 'undefined' && Sirv.SIRV && typeof Sirv.SIRV.update === 'function') {
            Sirv.SIRV.update();
        }
        const { modell, rahmenfarbe, kissenfarbe } = getSelectedValues();
        updateBild(modell, rahmenfarbe, kissenfarbe);
    });
}